const data = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About",
    url: "#about",
  },
  {
    title: "Roadmap",
    url: "#roadmap",
  },
  {
    title: "FAQ",
    url: "#faq",
  },
  {
    title: "Articles",
    url: "#",
  },
  {
    title: "Terms of Service",
    url: "#",
  },
];

export default data;
